import moment from "moment";

export function copyArrayObjByNoRef(paramArrObj) {
  let arrObj = [];
  paramArrObj = paramArrObj || [];
  for (var i = 0; i < paramArrObj.length; i++) {
    arrObj[i] = {};
    for (var prop in paramArrObj[i]) {
      arrObj[i][prop] = paramArrObj[i][prop];
    }
  }
  return arrObj;
}

export function dateFormatter(date) {
  if (date) {
    return moment(date).local().format("YYYY-MM-DD");
  } else {
    return "";
  }
}

export function dateFormatterUTC(date) {
  if (date) {
    return moment.utc(date).local().format("YYYY-MM-DD hh:mm A");
  } else {
    return "";
  }
}


export function dateFormat12hour(date) {
  if (date) {
    return moment(date).local().format("DD-MM-YYYY hh:mm A");
  } else {
    return "";
  }
}

export function formatLocalDateTime(date) {
  if (date) {
    return moment(date).local().format("YYYY-MM-DD hh:mm");
  } else {
    return "";
  }
}

export function dateFormatterDMY(date) {
  if (date) {
    return moment(date).local().format("DD/MM/YY");
  } else {
    return "";
  }
}

export function UIdateFormateNotTime(date) {
  if (date) {
    return moment(date).local().format("DD/MM/YYYY");
  } else {
    return "";
  }
}

export const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`; // Returns YYYY-MM-DD in local time
};

export const getPreviousMonthStartDate = () => {
  const today = new Date();
  const previousMonth = new Date(
    today.getFullYear(),
    today.getMonth() - 1,
    today.getDate()
  );
  const year = previousMonth.getFullYear();
  const month = String(previousMonth.getMonth() + 1).padStart(2, "0");
  const day = String(previousMonth.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`; // Returns YYYY-MM-DD in local time
};

export function ToIso8601Format(date) {
  if (date) {
    return moment(date).format();
  } else {
    return "";
  }
}

export function UIdateFormatter(date) {
  if (date) {
    return moment(date).local().format("DD/MM/YYYY HH:mm:ss");
  } else {
    return "";
  }
}

export function ConvertBlobToBase64String(blob) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    return reader.readAsDataURL(blob);
  });
}

export function showLast6Pin(pin) {
  if (!pin) return "-"; // Handle empty or undefined values
  let visiblePart = pin.slice(-7); // Last 6 characters + "#"
  let maskedPart = "*".repeat(pin.length - 7); // Mask the rest
  return maskedPart + visiblePart;
}

// if (searchKeyword != "" && searchingColumns != null && searchingColumns != "")
// {
//   let columns = searchingColumns.Split(",");
//   sWhere = " WHERE (";
//   for (var i = 0; i < columns.Length; i++) {
//     if(columns[i] == "lastSavedBy") columns[i] = GetLastSavedBy("createdBy", "updatedBy"); // to check createdBy and updatedBy
//     if(columns[i] == "lastSavedDate") columns[i] = GetLastSavedBy("createdDate", "updatedDate"); // to check createdDate and updatedDate
//     sWhere += columns[i] + " LIKE " + "N\'%" +  SQLSafe(searchKeyword) + "%\'" + " OR ";
//   }
//   sWhere = sWhere.Length >= 4 ? sWhere.Substring(0, sWhere.Length - 4) : sWhere;
//   sWhere += ")";
// }
// return sWhere;

let transactionTypes = [
  { label: "Remark", value: "Remark" },
  { label: "Eload Deposit", value: "EloadDeposit" },
  { label: "Opening Balance", value: "OpeningBalance" },
  { label: "Topup Withdrawal", value: "TopupWithdrawal" },
  { label: "Transfer Withdrawal", value: "TransferWithdrawal" },
  { label: "Eload Return", value: "EloadReturn" },
];

export { transactionTypes };
